export default __webpack_public_path__ + "static/media/makro.c4853dc3.svg";